<template>
  <div class="expandable-cards-wrapper container" data-aos="fade-up">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="expand-card"
      :class="{ 'is-active': activeIndex === index }"
      @mousemove="setActive(index)"
    >
      <div class="card-inner">
        <!-- 图片部分 -->
        <div class="card-image-box">
          <img :src="activeIndex === index ? item.image1 : item.image" :alt="item.title" class="card-img">
          <!-- 文字遮罩 (始终显示，展开与否样式不同) -->
          <div class="card-overlay-content" :class="{ 'is-expanded': activeIndex === index }">
            <div class="card-number">{{ item.number }}</div>
            <h3 class="card-title" v-html="item.title"></h3>
          </div>
        </div>

        <!-- 展开后的文字内容部分 -->
        <div class="card-text-content" v-if="activeIndex === index">
          <div class="text-inner">
            <h3 class="expanded-title">{{ stripHtmlTags(item.title) }}</h3>
            <p class="card-desc" v-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableCards',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  watch:{
    // 路由变化时，重置 activeIndex 为 0
    '$route'(to, from) {
      this.activeIndex = 0
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index
    },
    stripHtmlTags(text) {
      return text.replace(/<br\s*\/?>/gi, '');
    }
  }
}
</script>

<style lang="scss" scoped>
.expandable-cards-wrapper {
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
  // padding: 40px 0;
  padding-bottom: 20px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }
}

.expand-card {
  position: relative;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 0 28px -1px #1867f11a;
  /* 未展开状态 */
  width: 230px;
  height: 220px;
  color: #405270;
  border-radius: 6px;
  transition: all 0.5s ease;
transition-property: all, border;
transition-duration: 0.5s, 0s;

  &:not(.is-active) {
    // opacity:1;
    
    .card-image-box {
      // mix-blend-mode: overlay;
    }

    .card-overlay-content {
      .card-number {
        font-family: AlimamaShuHeiTi-Bold;
        font-weight: 700;
        font-size: 32px;
        color: #212F45;
        letter-spacing: 0;
        line-height: 34px;
      }
      .card-title {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 20px;
        color: #405270;
        letter-spacing: 0;
      }
    }
  }

  /* 展开状态 */
  &.is-active {
    flex: 1;
    min-width: 500px;
    height: 220px; /* 固定高度，若文字过多建议配合 overflow 或调整高度 */
    // opacity: 1;
    background: #FFFFFF;
    border: 1px solid #F5F8FC;
    // box-shadow: 0 0 32px 0 #1571ec1a;
    border-radius: 8px;
    // mix-blend-mode: normal;

    .card-image-box {
      width: 278px;
      height: 100%;
    }

    .card-overlay-content {
      .card-number {
        font-family: AlimamaShuHeiTi-Bold;
        font-weight: 700;
        font-size: 32px;
        color: #1571EC;
        letter-spacing: 0;
        line-height: 34px;
      }
      .card-title {
        color: #15243C;
      }
    }
  }
}

.card-inner {
  display: flex;
  width: 100%;
  height: 100%;
}

.card-image-box {
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  transition: width 0.5s ease;

  .card-img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }
}

.card-overlay-content {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 2;
  transition: all 0.5s ease;

  &.is-expanded {
    top: 30px;
    left: 40px;
  }

  .card-number {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 8px;
    transition: color 0.5s ease;
  }

  .card-title {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    line-height: 25px;
    font-weight: 600;
    transition: color 0.5s ease;
  }
}

.card-text-content {
  flex: 1;
  padding: 24px 32px; /* 适当减小 padding 以容纳更多文字 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden; /* 确保内容不溢出 */
  // animation: fadeIn 0.5s ease forwards;

  .text-inner {
    max-height: 100%;
    overflow-y: auto; /* 文字过多时允许内部滚动 */
    
    /* 隐藏滚动条但保留功能 */
    &::-webkit-scrollbar {
      width: 0;
    }

    .expanded-title {
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 18px;
      color: #15243C;
      letter-spacing: 0;
      line-height: 22px;
    }

    .card-desc {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #64768F;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .expandable-cards-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  .expand-card, .expand-card.is-active {
    width: 100%;
    height: auto;
    min-height: 200px;
    border-radius: 8px;
  }
  .card-inner {
    flex-direction: column;
  }
  .card-image-box {
    height: 200px;
  }
}
</style>